import { IRoutePermissions } from '../../types/common';
import { UserCapabilityName } from '../../types/userCapabilityName';

export const organizationMetricsRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewReports,
  ],
};
export const dashboardRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewReports,
  ],
};
export const organizationsRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewOrganizations,
    UserCapabilityName.OrganizationsAllView,
  ],
};
export const usersRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewUsers,
    UserCapabilityName.EndUserAllAdmin,
  ],
};
export const identityEventLogsRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewEventLogs,
  ],
};
export const unProtectedOpenRoutes = ['/logout'];
